import { GET_NOTICE } from "@/store/modules/mutation-types";

export default {
  actions: {
    async [GET_NOTICE]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/attendances/get_overtime",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  }
};
